:host {
  display: block;
  transform-style: preserve-3d;
}
